var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAkarIconsCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0679 22.234C8.17634 22.71 6.52368 23.8603 5.42043 25.4689C4.31718 27.0774 3.83929 29.0335 4.07654 30.9696C4.31379 32.9056 5.24985 34.6884 6.70885 35.983C8.16786 37.2776 10.0494 37.9948 11.9999 38H33.9999C35.412 37.999 36.8079 37.699 38.0956 37.1197C39.3834 36.5404 40.5339 35.6949 41.4714 34.6389C42.4088 33.583 43.112 32.3404 43.5347 30.9931C43.9573 29.6457 44.0898 28.2241 43.9235 26.8219C43.7571 25.4196 43.2957 24.0685 42.5695 22.8575C41.8433 21.6464 40.8689 20.6029 39.7104 19.7956C38.5519 18.9882 37.2355 18.4354 35.8479 18.1735C34.4603 17.9116 33.033 17.9465 31.6599 18.276L28.9999 19",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#02355A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6598 18.276C30.9763 15.5692 29.289 13.2235 26.9401 11.7146C24.5912 10.2056 21.7564 9.64623 19.0103 10.1499C16.2643 10.6535 13.8125 12.1824 12.152 14.4267C10.4914 16.671 9.74635 19.4628 10.0678 22.236C10.0678 22.236 10.3738 24 10.9998 25",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#02355A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsCloud);
export default __webpack_public_path__ + "static/media/akar-icons_cloud.2c4d4afc2f1e89aaf0d63db299b28092.svg";
export { ForwardRef as ReactComponent };